// Template for /case-studies/<slug> pages.
// Converted from https://www.dbos.dev/case-studies/dosu.

import type { CaseStudy } from '@content/types';
import { SiteLayout } from '@components/layout/SiteLayout';
import { FooterCtaBuildYourReliableBackend } from '@components/layout/FooterCtas';
import { Img } from '@components/cms/Img';
import { SlideIn } from '@components/interactions';
import { NavLink } from '@components/webflow';
import { cx } from '@components/webflow/element';

export function CaseStudyPage({ study, body }: { study: CaseStudy; body: string }) {
  return (
    <SiteLayout banner={false} footerCta={<FooterCtaBuildYourReliableBackend />}>
      <style dangerouslySetInnerHTML={{ __html: 'body {\n    overflow-x: visible !important;\n  }' }} />
      <section className="section_case-study">
        <SlideIn className="padding-global" as="div">
          <div className="container-large">
            <div className="padding-section-small">
              <div className="partner_component">
                <div className="partner_sidebar">
                  <div className="margin-bottom margin-breadcrumb">
                    <div className="div-block-80">
                      <a href="/customer-stories" className="button-4 tertiary-large-15 w-inline-block">
                        <div className="icon-arrow-left-2 tertiary-large-16 w-embed">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M10.5892 5.58917L9.41083 4.41084L3.82167 10L9.41083 15.5892L10.5892 14.4108L7.01167 10.8333L15 10.8333L15 9.16667L7.01167 9.16667L10.5892 5.58917Z"
                              fill="var(--_color-scheme-july-2025---headings)"
                            />
                            {'\n'}
                          </svg>
                        </div>
                        <div className="text-block-11 tertiary-large-17">Back to case studies</div>
                      </a>
                    </div>
                  </div>
                  <div className="margin-bottom margin-small">
                    <div className="partner_header">
                      <div className="partner_logo-wrapper">
                        <Img image={study.logo} loading="lazy" className="partner_logo" />
                      </div>
                      <div className="partner_title">
                        <h3 className="heading-style-h5">{study.name}</h3>
                        <p className="tagline-container text-size-small">{study.industry}</p>
                      </div>
                      <p className="text-body text-alignment-left">{study.description}</p>
                      <div className="partner_attribute">
                        <p className="text-size-regular text-weight-regular">Website</p>
                        <a
                          href={study.website || '#'}
                          className={cx(
                            'text-body-active text-size-regular is-partner',
                            !study.website && 'w-dyn-bind-empty',
                          )}
                        >
                          {study.website}
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="partner_header-2">
                    <h3 className="heading-style-h5-2">Get started for free</h3>
                    <div className="text-body-2-2 text-size-regular">Launch your reliable software in minutes.</div>
                    <div className="button-group-3 is-partner">
                      <div className="button-wrapper-2">
                        <a href="https://console.dbos.dev/" className="button-5 w-inline-block">
                          <div className="text-block-12">Start building</div>
                          <div className="icon-chevron-right-3 w-embed">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                fill="#F3F6F8"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </a>
                      </div>
                      <div className="button-wrapper-2 secondary-large-2">
                        <a
                          href="https://calendly.com/alex-poliakov-dbos/30min"
                          className="button-5 secondary-large-3 w-inline-block"
                        >
                          <div className="text-block-12 secondary-large-5">Book a demo</div>
                          <div className="icon-chevron-right-3 secondary-large-7 w-embed">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                fill="#F3F6F8"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="max-width-xlarge is-column">
                  <div className="margin-bottom margin-medium">
                    <h2 className="text-heading-h1 text-heading-styling-hero text-alignment-left">{study.title}</h2>
                  </div>
                  <div
                    className={cx('text-body-rich w-richtext', !body && 'w-dyn-bind-empty')}
                    dangerouslySetInnerHTML={{ __html: body }}
                  />
                </div>
              </div>
            </div>
          </div>
        </SlideIn>
      </section>
      <section className="section_related-cases">
        <SlideIn className="padding-global" as="div">
          <div className="container-large">
            <div className="padding-section-large padding-top">
              <div className="margin-bottom margin-medium">
                <div className="text-align-center">
                  <div className="margin-bottom margin-xsmall">
                    <div className="tagline-container_glow">
                      <h2 className="text-size-small tagline-container is-glow">Customer Stories</h2>
                    </div>
                  </div>
                  <div className="margin-bottom margin-small is-partner">
                    <h3 className="heading-style-h2">More success stories</h3>
                  </div>
                </div>
              </div>
              <div fs-list-filteringclass="is-list-filtering" className="partnerships_featured-list-wrapper w-dyn-list">
                <div role="list" className="partnerships_featured-list w-dyn-items">
                  <div role="listitem" className="partnerships_featured-item w-dyn-item">
                    <div className="partnerships_header is-customer-stories">
                      <div className="partner_logo-wrapper">
                        <img
                          src="/assets/cms/69fd6ec70fa83aed3726042b_Ordeful-Icon-DBOS.png"
                          loading="lazy"
                          alt=""
                          className="partner_logo"
                        />
                      </div>
                      <p className="tagline-container text-size-small">Enterprise Integration Software</p>
                    </div>
                    <div className="partnerships_content">
                      <div className="margin-bottom margin-tiny">
                        <h3 className="heading-style-h5">Orderful</h3>
                      </div>
                      <p className="text-body-active">
                        Orderful is modernizing EDI for retail, logistics, and supply chain. Orderful replaced RabbitMQ
                        with DBOS to run 2 million transaction processing workflows a day.
                      </p>
                    </div>
                    <div
                      data-wf--button--variant="tertiary-large"
                      className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                    >
                      <NavLink
                        className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                        href="/case-studies/orderful-resilient-edi-at-scale"
                      >
                        <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                          Read case study
                        </div>
                        <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                              fill="#F3F6F8"
                            />
                            {'\n'}
                          </svg>
                        </div>
                      </NavLink>
                    </div>
                  </div>
                  <div role="listitem" className="partnerships_featured-item w-dyn-item">
                    <div className="partnerships_header is-customer-stories">
                      <div className="partner_logo-wrapper">
                        <img
                          src="/assets/cms/69fd79a91bc4b49823477e89_Run-Riviera-Icon-DBOS.png"
                          loading="lazy"
                          alt=""
                          className="partner_logo"
                        />
                      </div>
                      <p className="tagline-container text-size-small">AI - Healthcare</p>
                    </div>
                    <div className="partnerships_content">
                      <div className="margin-bottom margin-tiny">
                        <h3 className="heading-style-h5">Riviera</h3>
                      </div>
                      <p className="text-body-active">
                        DBOS ensures backend AI CRM workflows execute reliably and with full observability amid software
                        updates, system failures, and unpredictable humans in the loop.
                      </p>
                    </div>
                    <div
                      data-wf--button--variant="tertiary-large"
                      className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                    >
                      <NavLink
                        className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                        href="/case-studies/riviera-ai-powered-crm-elective-healthcare"
                      >
                        <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                          Read case study
                        </div>
                        <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                              fill="#F3F6F8"
                            />
                            {'\n'}
                          </svg>
                        </div>
                      </NavLink>
                    </div>
                  </div>
                  <div role="listitem" className="partnerships_featured-item w-dyn-item">
                    <div className="partnerships_header is-customer-stories">
                      <div className="partner_logo-wrapper">
                        <img
                          src="/assets/cms/6a0de1aaed314508a8b6d934_FlowGen_Labs-Icon-DBOS.png"
                          loading="lazy"
                          alt=""
                          className="partner_logo"
                        />
                      </div>
                      <p className="tagline-container text-size-small">AI - Agentic ERP Ops</p>
                    </div>
                    <div className="partnerships_content">
                      <div className="margin-bottom margin-tiny">
                        <h3 className="heading-style-h5">FlowGen Labs</h3>
                      </div>
                      <p className="text-body-active">
                        FlowGen Labs selected DBOS over Temporal to make long-lived workflows durable and observable
                        within the rigid security constraints of customer environments, including air-gapped
                        deployments.
                      </p>
                    </div>
                    <div
                      data-wf--button--variant="tertiary-large"
                      className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                    >
                      <NavLink
                        className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                        href="/case-studies/flowgen-labs"
                      >
                        <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                          Read case study
                        </div>
                        <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                              fill="#F3F6F8"
                            />
                            {'\n'}
                          </svg>
                        </div>
                      </NavLink>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SlideIn>
      </section>
    </SiteLayout>
  );
}
